const colors = {
  red: '#ff5f66',
  green: '#1abe8a',
  blur: '#4398ff',
  yellow: '#ffa529',
  purple: '#8b60f0'
}

export const HEADER_BG_GRADIENT = {
  '#894fd5': '#4d26bf',
  '#2a67e6': '#2a5fe4',
  '#0fc26d': '#00964f',
  '#f74c4c': '#d83f3f',
  '#3d495a': '#1d2735'
}

export const SVGREG = /^\/.+\.svg$/

export const TITLE = '铸剑'

export const SVGPATH = 'https://erphostjs.kye-erp.com/module-icon'

export const systemIconColors = {
  COO: colors.blur,
  CRM: colors.green,
  EC: colors.red,
  ECMS: colors.purple,
  FMS: colors.yellow,
  HOME: colors.purple,
  HRMS: colors.green,
  IAAMS: colors.green,
  IMS: colors.red,
  KTS: colors.yellow,
  KYETREE: colors.yellow,
  MAP: colors.purple,
  MCS: colors.blur,
  NET: colors.purple,
  OAMS: colors.green,
  OEM: colors.blur,
  PMS: colors.yellow,
  RBAC: colors.red,
  SYS: colors.purple,
  TDS: colors.green,
  TIC: colors.blur,
  TMS: colors.purple,
  URM: colors.blur,
  VMS: colors.purple
}



// WEBPACK FOOTER //
// ./src/layout/layout/conf.js